module.exports = __webpack_public_path__ + "back_trans.b961585a.png";